import {Component, OnInit} from '@angular/core';
import {AssinantesService} from "./assinantes.service";
import {AssinantesModel} from "./assinantes.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal, moment: any;

@Component({
  selector: 'app-assinantes',
  templateUrl: './assinantes.component.html'
})
export class AssinantesComponent extends Components implements OnInit {

  assinantes: AssinantesModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listNotificacoes = [];

  constructor(
    private assinantesService: AssinantesService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        const p = data.privilegios[i];
        const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
        const idAcao = String(p.id_acao || '');

        if(idAcao === '20' || acaoUrl == 'assinantes' || acaoUrl == 'prestacao-mapa' || acaoUrl == 'mercado-interno'){
          this.privilegioUsuario.consultar = p.consultar;
          this.privilegioUsuario.editar = p.editar;
        }
      }
      if(this.func.userIsMaster()){
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });
  }

  ngOnInit() {
    this.getPage(1);
  }

  delete(assinante) {
    let assinantes = this.assinantes;
    let assinantesService = this.assinantesService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarAssinante')+assinante.usuario.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(assinantes);
        }

        let index = assinantes.indexOf(assinante);
        assinantes.splice(index, 1);

        assinantesService.apagar(assinante.id_assinante)
          .subscribe(res => {
              self.assinantes = assinantes;
            },
            err => {
              // Revert the view back to its original state
              assinantes.splice(index, 0, assinante);
              self.assinantes = assinantes;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.assinantesService.getPaginacao(pagina,this.itensPorPagina, ["usuario"])
      .subscribe(data => {
        this.assinantes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/assinantes/assinantes.component.ts